// extracted by mini-css-extract-plugin
export default {"root":"_2QWUv4Hb","item":"_3sFXNaBY","icon":"_3n6zxcd5","wrapper":"_3znO4qT1","title":"_3FTRGeLP","content":"_1WIzazIM"};